import { render, staticRenderFns } from "./IncidentPopup.vue?vue&type=template&id=0806474b&"
import script from "./IncidentPopup.vue?vue&type=script&lang=js&"
export * from "./IncidentPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports